export const tourisms = [
    {
        name: "Pantai Lugina",
        position: [-7.444049767848112, 106.98226153850557],
        icon: 'beach',
    },
    {
        name: "Pantai Cikakap",
        position: [-7.4413297, 106.9469213],
        icon: 'beach',
    },
    {
        name: "Lapangan Sepak Bola Pasir Bayur",
        position: [-7.410580048951256, 106.98352754116058],
        icon: 'soccer-field',
    }
];